import React from "react";

export const withAttrs = (Component: React.ElementType, attrs: any) => (props: any) => (
  <Component {...attrs} {...props} />
);
